import React from "react";
import UmamiAnalytics from "./umami/UmamiAnalytics";
import MatomoAnalytics from "./matomo/MatomoAnalytics";

var AnalyticsSwitch = function AnalyticsSwitch(_ref) {
  var disabled = _ref.disabled,
      umami = _ref.umami,
      matomo = _ref.matomo;
  if (disabled) return "";
  return /*#__PURE__*/React.createElement(React.Fragment, null, umami && umami.enabled && /*#__PURE__*/React.createElement(UmamiAnalytics, umami), matomo && matomo.enabled && /*#__PURE__*/React.createElement(MatomoAnalytics, matomo));
};

AnalyticsSwitch.defaultProps = {
  disabled: false
};
export default AnalyticsSwitch;